module.exports = __webpack_public_path__ + "img/image6.df815785.jpg";